/**
 * Product-card star ratings from Bazaarvoice, matched to the Yotpo treatment
 * they replace.
 *
 * Two things CSS cannot do:
 *
 *   FORMAT. Bazaarvoice writes the count as "(1436)". Yotpo wrote
 *   "1436 Reviews", which is what the cards were designed around.
 *
 *   NOTHING TO SAY. A product with no reviews renders "(0)" — five empty stars
 *   and a zero, which reads worse on a card than no rating at all. Hidden
 *   instead.
 *
 * Bazaarvoice re-renders its widgets, so each container is watched and the
 * change re-applied rather than done once. The guard against rewriting text
 * that already matches is what stops the observer retriggering itself.
 */
(function () {
  var SELECTOR = '[data-bv-show="inline_rating"]';

  function apply(host) {
    // Bazaarvoice writes style="width:15px !important" onto each star inline,
    // which no stylesheet can override — inline !important wins. Yotpo's cards
    // used 14px, so it is set here instead.
    host.querySelectorAll("svg").forEach(function (svg) {
      if (svg.style.getPropertyValue("width") !== "14px") {
        svg.style.setProperty("width", "14px", "important");
        svg.style.setProperty("height", "14px", "important");
      }
    });

    var el = host.querySelector(".bv_text");
    if (!el) return;

    var digits = el.textContent.replace(/[^\d]/g, "");
    if (!digits) return;

    var count = parseInt(digits, 10);
    if (!count) {
      host.setAttribute("data-bv-empty", "true");
      return;
    }
    host.removeAttribute("data-bv-empty");

    // Plain digits, not toLocaleString: this store renders in a locale that
    // groups with a space, so 1436 came out as "1 436".
    var wanted = count + (count === 1 ? " Review" : " Reviews");
    if (el.textContent.trim() !== wanted) el.textContent = wanted;
  }

  function watch(host) {
    if (host.__bvWatched) return;
    host.__bvWatched = true;
    apply(host);
    new MutationObserver(function () {
      apply(host);
    }).observe(host, { childList: true, subtree: true, characterData: true });
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(watch);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  // Cards arrive after load too — filtering, pagination, quick views.
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
